export const REFRESH_PERMISSIONS = 'permissions:refresh';
